import { ActionTree } from "vuex";
import {
  PantryState,
  RootState,
  PantryList,
  RequestPantryList,
  RequstPantryPlateDetail,
  RequstPantryPlateSettingWeight,
  RequstPantryConsumeFoods,
  RecipeFoods,
  RequestPantrySearch,
  RequestRecommendRecipe,
  DeletePantryInfo,
  RequestRecognitionCandidateItem,
  RecognitionCandidate,
  RankingFoods,
  FavoriteFoods,
  PurChasedFoods,
  RegisterScanIngredients,
  RegisterPantryFridgeList,
  RegisterFood,
  RequestFavoriteFood,
  RequestUpdateFoodData,
  RequestUpdatePlateFoodData,
  RequestUpdateFridgeFoodData,
  PutRecognitionCandidateRequest,
  RequestFoodRecommendation,
  PantryItemsConsumeFoodList,
  PutRecognitionCandidate,
  RequestShoppingFoods,
  RequestFridgeItemsConfirm,
  SaveAddFoodItemData,
  SaveDeleteFoodItemData,
  RequstCameraImage,
  CameraImageItem,
  RequestFoodUpdate,
  CameraImageUrlItem,
  PantryOpticalAxis,
  RequestRecipeFoods
} from "@/types/pantry";
import { Recipes } from "@/types/recipes";
import { Product } from "@/types/common";
import store from "@/store";
import apiClient from "@/client/api-client";
import imageDownloadClient from "@/client/image-download-client";
import {
  API_URL_DEVICE,
  API_URL_MENU,
  API_URL_PANTRY,
  API_URL_RECIPE,
  API_URL_PLATE
} from "@/const/api-const";
import NativeClient from "@/client/native-client";
import { response, urlencoded } from "express";
import DateUtil from "@/utils/date-util";
import { COMMON_LIMIT_NUM } from "@/const/limit_const";
import { getApplianceListText } from "@/utils/search-util";
const config = {
  responseType: "arraybuffer"
};

const actions: ActionTree<PantryState, RootState> = {
  updatePantryList: async ({ commit }, pantryList: PantryList | null) => {
    commit("updatePantryList", pantryList);
  },
  getPantryList: async ({ commit }, payload: RequestPantryList) => {
    NativeClient.sendDebugLog(
      "[Paging]actions getPantryList payload=" + JSON.stringify(payload)
    );
    // パントリー一覧API呼び出し
    const res = await apiClient.get(API_URL_PANTRY.LIST, {
      params: {
        // My家電ID
        order: payload.order,
        // 取得開始位置
        start: payload.start,
        row: payload.row
      }
    });
    commit("updatePantryList", res.data);
  },
  updatePantryVirtualList: async ({ commit }, pantryList: PantryList | null) => {
    commit("updatePantryVirtualList", pantryList);
  },
  getPantryVirtualList: async ({ commit }, payload: RequestPantryList) => {
    NativeClient.sendDebugLog(
      "[Paging]actions getPantryVirtualList payload=" + JSON.stringify(payload)
    );
    // パントリー一覧API呼び出し
    const res = await apiClient.get(API_URL_PANTRY.LIST, {
      params: {
        // My家電ID
        order: "shortexpired",
        // 取得開始位置
        start: payload.start,
        row: payload.row
      }
    });
    commit("updatePantryVirtualList", res.data);
  },
  getUsedUpPantryList: async ({ commit }, payload: RequestPantryList) => {
    const pantry: PantryList | null =
      store.getters["pantry/getUsedUpPantryList"];
    if (pantry && pantry.pantryList) {
      if (pantry.totalCount <= pantry.pantryList.length) {
        return;
      }
    }
    // すでに取得済みの場合、取得した件数以降の開始位置を指定
    const start = pantry && pantry.pantryList ? pantry.pantryList.length : 0;
    // パントリー一覧API呼び出し
    const res = await apiClient.get(API_URL_PANTRY.LIST, {
      params: {
        // My家電ID
        order: payload.order,
        // 取得開始位置
        start: start,
        // 取得件数は 30 件固定
        row: COMMON_LIMIT_NUM.PANTRY_LIST_ITEM_LIMIT
      }
    });
    commit("updateUsedUpPantryList", res.data);
  },
  getPantryCosumeFoods: async (
    { commit },
    payload: RequstPantryConsumeFoods
  ) => {
    // パントリー重量検知プレート食材残量経過取得API呼び出し
    const res = await apiClient.post(API_URL_PANTRY.CONSUME_FOODS, {
      params: {
        // アプリ保持前回時刻
        lastdate: payload.lastdate,
        // 取得開始位置
        start: payload.start,
        // 取得件数は 30 件固定
        row: COMMON_LIMIT_NUM.PANTRY_LIST_ITEM_LIMIT
      }
    });
    commit("updatePantryConsumeFoods", res.data);
  },
  getPantryDetail: async ({ commit }, pantryId: number) => {
    // パントリー詳細API呼び出し
    const apiPath = API_URL_PANTRY.DETAIL.replace(
      "$pantryId",
      pantryId.toString()
    );
    const res = await apiClient.get(apiPath);
    commit("updatePantryDetail", res.data);
  },
  getPantryPlateDetail: async (
    { commit },
    payload: RequstPantryPlateDetail
  ) => {
    // パントリー重量検知プレート食材詳細API呼び出し
    const res = await apiClient.post(API_URL_PANTRY.PLATE_DETAIL, payload);
    commit("updatePantryPlateDetail", res.data);
  },
  getPantryPlateSettingWeight: async (
    { commit },
    payload: RequstPantryPlateSettingWeight
  ) => {
    // パントリー重量検知プレート食材残量経過取得API呼び出し
    const res = await apiClient.post(
      API_URL_PANTRY.PLATE_SETTING_WEIGHT,
      payload
    );
    commit("updatePantryPlateSettingWeight", res.data);
  },
  getPantryFridgeDetail: async ({ commit }, pantryFridgeId: number) => {
    // パントリー冷蔵庫食材詳細API呼び出し
    const apiPath = API_URL_PANTRY.FRIDGE_DETAIL.replace(
      "$pantryFridgeId",
      pantryFridgeId.toString()
    );
    const res = await apiClient.get(apiPath);
    commit("updatePantryFridgeDetail", res.data);
  },
  getFridgeListInfo: async ({ commit }, applianceId: string) => {
    // パントリー庫内情報取得API呼び出し
    const res = await apiClient.post(API_URL_PANTRY.FRIDGE_INFO, {
      // 通信用機器ID
      applianceId: applianceId
    });
    commit("updatePantryFridgeListInfo", res.data);
  },
  getRecognitionCandidate: async (
    { commit },
    payload: RequestRecognitionCandidateItem
  ) => {
    let i = 0;
    // パントリー：冷蔵庫食材認識修正候補取得API呼び出し
    const apiPath = API_URL_PANTRY.FRIDGE_RECOGNITION_CANDITATE.replace(
      "$inferenceResultFoodId",
      payload.inferenceResultFoodId.toString()
    );
    const res = await apiClient.post(apiPath, {
      // 通信用機器ID
      applianceId: payload.applianceId
    });
    const resData = new RecognitionCandidate(0, payload.inferenceResultFoodId, payload.applianceId);
    resData.set(res.data);
    commit(
      "updateRecognitionCandidateMap",
      resData
    );
    i++;
  },
  putRecognitionCandidate: async (
    { commit },
    payload: PutRecognitionCandidateRequest
  ) => {
    const apiPath = API_URL_PANTRY.FRIDGE_RECOGNITION_CANDITATE.replace(
      "$objectId",
      payload.objectId.toString()
    );
    const data = new PutRecognitionCandidate(payload.data.ingredientId, payload.data.userFixName);
    if (data.ingredientId != null && data.userFixName != null) {
      data.userFixName = null;
    }
    const res = await apiClient.put(apiPath, data);
  },
  getTagGroups: async ({ commit }) => {
    // パントリー：冷蔵庫認識食材一覧取得API呼び出し
    const res = await apiClient.get(API_URL_RECIPE.TAGS);
    commit("updateTagGroups", res.data);
  },
  updateSearchRecipes: async ({ commit }, recipes: Recipes | null) => {
    commit("updateSearchRecipes", recipes);
  },
  getSearchRecipes: async ({ commit }, payload: RequestPantrySearch) => {
    // Nativeから受け取った認証関連パラメータを取得
    const apiParams = store.getters["common/getApiBaseParams"];
    const personalizedOption = payload.targetAll
      ? "pantryBase"
      : "pantryBase pantryOnly";
    // すでに取得済みの場合、取得した件数以降の開始位置を指定
    const applianceText = getApplianceListText(apiParams.applianceList);
    let productId = applianceText;
    if (productId == null) {
      productId = "NO_APPLIANCE"
    } else {
      productId += " ";
      productId += "NO_APPLIANCE";
    }
    // レシピ検索API呼び出し
    const res = await apiClient.get(API_URL_RECIPE.SEARCH, {
      params: {
        // My家電ID
        myAppliance: applianceText != null ? applianceText : null,
        // ProductId
        productId: productId,
        // 取得開始位置
        start: payload.start,
        // 取得件数は 9 件固定
        row: payload.rows,
        // 検索結果のソート順：一致
        order: "personalized",
        // タグ
        personalizedOption: personalizedOption,
        // 検索キーワード
        q: payload.keywords,
        // 食材ID(foodId)
        foodId: payload.foodIds,
        // タグ
        tags: payload.tags != "" ? payload.tags : null
      }
    });
    commit("updateSearchRecipes", res.data);
  },
  updateRecipeFoods: async ({ commit }, recipeFoods: RecipeFoods | null) => {
    commit("updateRecipeFoods", recipeFoods);
  },
  getRecipeFoods: async ({ commit }, keyword: string) => {
    // すでに全件取得済みの場合はなにもしない
    const recipes: Recipes | null = store.getters["pantry/getRecipeFoods"];
    if (recipes && recipes.recipes) {
      if (recipes.totalCount <= recipes.recipes.length) {
        return;
      }
    }
    // すでに取得済みの場合、取得した件数以降の開始位置を指定
    const start = recipes && recipes.recipes ? recipes.recipes.length : 0;
    // レシピ検索API呼び出し
    const res = await apiClient.get(API_URL_RECIPE.SEARCH_FOODS, {
      params: {
        // 取得開始位置
        start: start,
        // 取得件数
        row: 10,
        // 検索結果のソート順：一致
        q: keyword
      }
    });
    commit("updateRecipeFoods", res.data);
  },
  getRecipeFoodMap: async ({ commit }, payload: RequestRecipeFoods) => {
    if (payload.ids.length != 0) {
      const row = payload.ids.length;
      const idsString = payload.getIdsString();
      // レシピ検索API呼び出し
      const res = await apiClient.get(API_URL_RECIPE.SEARCH_FOODS, {
        params: {
          ids: idsString,
          // 取得開始位置
          start: 0,
          // 取得件数
          row: row
        }
      });
      commit("updateRecipeFoodMap", res.data);
      return;
    }
    commit("updateRecipeFoodMap", null);
  },
  updateRecommendRecipe: async (
    { commit },
    recommnedRecipes: Recipes | null
  ) => {
    commit("updateRecommendRecipes", recommnedRecipes);
  },
  getRecommendRecipe: async ({ commit }, payload: RequestRecommendRecipe) => {
    // すでに全件取得済みの場合はなにもしない
    const recipes: Recipes | null = store.getters["pantry/getRecommendRecipes"];
    if (recipes && recipes.recipes) {
      if (recipes.totalCount <= recipes.recipes.length) {
        return;
      }
    }
    // おすすめAPI呼び出し
    const res = await apiClient.get(API_URL_RECIPE.SEARCH, {
      params: {
        // おすすめレシピ
        order: "recommend",
        // 取得開始位置
        start: 0,
        // 取得件数
        row: 10,
        // ProductId
        productId: "NO_APPLIANCE",
        // 検索キーワード
        q: payload.foodId != null ? null : payload.keyword,
        // 食材ID(foodId)
        foodId: payload.foodId
      }
    });
    commit("updateRecommendRecipes", res.data);
  },
  getSearchFood: async ({ commit }, payload: RequestRecommendRecipe) => {
    // すでに全件取得済みの場合はなにもしない
    const recipes: Recipes | null = store.getters["pantry/getRecipeFoods"];
    if (recipes && recipes.recipes) {
      if (recipes.totalCount <= recipes.recipes.length) {
        return;
      }
    }
    // レシピ検索API呼び出し
    const res = await apiClient.get(API_URL_RECIPE.SEARCH_FOODS, {
      params: {
        // 取得開始位置
        start: 0,
        // 取得件数は 1 件固定
        row: 1,
        // 検索キーワード
        q: payload.foodId != null ? null : payload.keyword,
        // 食材ID(foodId)
        ids: payload.foodId
      }
    });
    commit("updateRecipeFoods", res.data);
  },
  getCameraImageLoad: async ({ commit }, payload: RequstCameraImage) => {
    const host = "https://cdn.dev1.kitchen-appliances-pf.com";
    let imageUrl = "";
    if (process.env.VUE_APP_API_PATH == null) {
      imageUrl = payload.imageUrl;
    } else {
      if (process.env.VUE_APP_LOCAL_DEBUG_IP == null) {
        imageUrl = payload.imageUrl.substring(host.length);
        imageUrl = "http://localhost:8081" + imageUrl;
      } else {
        imageUrl = payload.imageUrl.substring(host.length);
        imageUrl = "http://192.168.10.169:8081" + imageUrl;
      }
    }
    // TODO:以下の処理はデバッグコード
    // imageUrl = payloadItem.imageUrl.substring(host.length);
    // imageUrl = "http://localhost:8081" + imageUrl;
    NativeClient.sendDebugLog(
      "Pantry_Action.ts getImageLoadInfo imageUrl=" + imageUrl
    );
    const response = await imageDownloadClient.get(imageUrl);
    const bstr = new Buffer(response.data, "binary").toString("base64");
    // NativeClient.sendDebugLog(
    //   "Pantry_Action.ts getImageLoadInfo bstr=" + JSON.stringify(bstr)
    // );
    const item = new CameraImageItem(payload, bstr);
    commit("updateCameraImageMap", item);
  },
  getRankingFoods: async ({ commit }) => {
    // すでに取得済みの場合はなにもしない(ページング対象外)
    const recipes: RankingFoods | null =
      store.getters["pantry/getRankingFoods"];
    if (recipes && recipes.foods) {
      return;
    }
    const date = DateUtil.getToday();
    // ユーザー食品利用ランキング取得
    const res = await apiClient.get(API_URL_RECIPE.RANKING_FOODS, {
      params: {
        // 算出基準日
        baseDate: date,
        // ランキング集計期間(日数)
        term: 30
      }
    });
    commit("updateRankingFoods", res.data);
  },
  getFavoriteFoods: async ({ commit }) => {
    // すでに取得済みの場合はなにもしない(ページング対象外)
    const recipes: FavoriteFoods | null =
      store.getters["pantry/getFavoriteFoods"];
    if (recipes && recipes.foods) {
      return;
    }
    // お気に入り食品(一覧取得)API
    const res = await apiClient.get(API_URL_RECIPE.FAVORITE_FOODS, {
      params: {
        // ソート順
        order: "newest",
        // 検索結果取得開始行 HITした1番最初から取得
        start: 0,
        // 検索結果取得件数
        row: COMMON_LIMIT_NUM.INSTRUCTION_LIST_ITEM_LIMIT
      }
    });
    commit("updateFavoriteFoods", res.data);
  },
  getMenuCategories: async ({ commit }) => {
    const categories = store.getters["pantry/getMenuCategories"];
     // すでに取得済みの場合はなにもしない(ページング対象外)
    if (categories) {
      return;
    }
    // シーン別検索を行う際のカテゴリ一覧を取得するAPI
    const res = await apiClient.get(API_URL_MENU.MENU_CATEGORIES, {
      params: {
        // シーン一覧
        scene: "pantry"
      }
    });
    commit("updateMenuCategories", res.data);
  },
  getPurChasedFoods: async ({ commit }) => {
    // すでに取得済みの場合はなにもしない(ページング対象外)
    const recipes: PurChasedFoods | null =
      store.getters["pantry/getPurChasedFoods"];
    if (recipes && recipes.foods) {
      return;
    }
    // シーン別検索を行う際のカテゴリ一覧を取得するAPI
    const res = await apiClient.get(API_URL_PANTRY.PURCHASED_FOODS, {
      params: {
        // ページング用 検索結果開始行
        start: 0,
        // ページング用 取得件数
        row: COMMON_LIMIT_NUM.INSTRUCTION_LIST_ITEM_LIMIT
      }
    });
    commit("updatePurChasedFoods", res.data);
  },
  deletePantry: async ({ commit }, payload: DeletePantryInfo) => {
    const res = await apiClient.post(API_URL_PANTRY.DELETE, payload);
  },
  registerFridgeFood: async ({ commit }, payload: RegisterPantryFridgeList) => {
    if (payload.objects.length != 0) {
      const res = await apiClient.post(API_URL_PANTRY.FRIDGE_REGISTER, payload);
    }
  },
  registerScanIngredients: async (
    { commit },
    payload: RegisterScanIngredients
  ) => {
    if (payload.pantryList.length != 0) {
      const res = await apiClient.post(
        API_URL_PANTRY.SCAN_INGREDIENTS_REGISTER,
        payload
      );
    }
  },
  registerFood: async ({ commit }, payload: RegisterFood) => {
    const res = await apiClient.post(API_URL_PANTRY.FOOD_REGISTER, payload);
  },
  addFavoriteFood: async ({ commit }, payload: RequestFavoriteFood) => {
    const res = await apiClient.post(API_URL_RECIPE.FAVORITE_FOOD, payload);
  },
  removeFavoriteFood: async ({ commit }, payload: RequestFavoriteFood) => {
    const apiPath = API_URL_RECIPE.FAVORITE_FOOD_QUERY.replace(
      "$foodId",
      payload.foodId.toString()
    );

    const res = await apiClient.delete(apiPath);
  },
  getFavoriteFood: async ({ commit }, payload: RequestFavoriteFood) => {
    const apiPath = API_URL_RECIPE.FAVORITE_FOOD_QUERY.replace(
      "$foodId",
      payload.foodId.toString()
    );
    const res = await apiClient.get(apiPath);
    commit("updateFavoriteFood", res.data);
  },
  updatePantry: async ({ commit }, data: RequestUpdateFoodData) => {
    const apiPath = API_URL_PANTRY.DETAIL.replace(
      "$pantryId",
      data.pantryId.toString()
    );
    const res = await apiClient.put(apiPath, data.payload);
  },
  updatePlatePantry: async ({ commit }, data: RequestUpdatePlateFoodData) => {
    const apiPath = API_URL_PANTRY.UPDATE_PLATE_DETAIL.replace(
      "$pantryPlateId",
      data.pantryId.toString()
    );
    const res = await apiClient.put(apiPath, data.payload);
  },
  updateFridgePantry: async ({ commit }, data: RequestUpdateFridgeFoodData) => {
    const apiPath = API_URL_PANTRY.FRIDGE_ITEM.replace(
      "$pantryFridgeId",
      data.pantryId.toString()
    );
    const res = await apiClient.put(apiPath, data.payload);
  },
  updateProducts: async ({ commit }, products: Array<Product> | null) => {
    commit("updateProducts", products);
  },
  getProducts: async ({ commit }) => {
    const products: Array<Product> | null = store.getters["search/getProducts"];
    // すでに全件取得済みの場合はなにもしない
    if (products) {
      return;
    }
    // レシピ検索API呼び出し
    const res = await apiClient.get(API_URL_DEVICE.REGISTERED, {
      params: {
        // IoT対象
        isIotDevice: null
      }
    });
    commit("updateProducts", res.data);
  },
  getPlateDeviceMode: async ({ commit }, payload: RequstPantryPlateDetail) => {
    // プレート設定取得API
    const res = await apiClient.post(API_URL_PLATE.SETTINGS, payload);
    commit("updatePlateDeviceMode", res.data);
  },
  // 食品提案
  getFoodRecommendationList: async ({ commit }, payload: RequestFoodRecommendation) => {
    const res = await apiClient.get(API_URL_RECIPE.FOODS_RECOMMENDATION, {
      params: {
        pattern: "auto",
        uncheckedShoppingFoods: payload.uncheckedId,
        row: 1
      }
    });

    NativeClient.sendDebugLog("Acrtion.ts getFoodRecommendationList res.data = " + JSON.stringify(res.data));

    // 保存する
    commit("updateFoodRecommendationList", res.data);
  },
  getFoodConsumeList: async ({ commit }) => {
    const foods: PantryItemsConsumeFoodList | null = store.getters["pantry/getFoodCusumeList"];
    if (foods && foods.pantryList) {
      return;
    }
    // パントリー消費済み食材一覧取得
    const res = await apiClient.get(API_URL_PANTRY.FOODS_CONSUMED, {
      params: {
        // 取得開始
        start: 0,
        // 件数
        row: COMMON_LIMIT_NUM.INSTRUCTION_LIST_ITEM_LIMIT
      }
    });
    commit("updateFoodConsumeList", res.data);
  },
  registerShoppingFoods: async ({ commit }, payload: RequestShoppingFoods) => {
    const res = await apiClient.post(API_URL_PANTRY.FOODS_REGIST, payload);
  },
  getFridgeItemsJudge: async ({ commit }) => {
    const items = store.getters["pantry/getFridgeItemsJudge"];
    // すでに取得済みの場合はなにもしない(ページング対象外)
    if (items) {
      return;
    }
    // パントリー：冷蔵庫食材判定
    const res = await apiClient.post(API_URL_PANTRY.FRIDGE_ITEMS_JUDGE);
    commit("updateFridgeItemsJudge", res.data);
  },
  setFridgeItemsConfirm: async ({ commit }, payload: RequestFridgeItemsConfirm) => {
    // パントリー：冷蔵庫食材確認
    const res = await apiClient.post(API_URL_PANTRY.FRIDGE_ITEMS_CONFIRM, payload);
  },
  setFoodUpdate: async ({ commit }, payload: RequestFoodUpdate) => {
    if (payload.confirm) {
      // パントリー：冷蔵庫食材確認
      const res = await apiClient.post(API_URL_PANTRY.FRIDGE_ITEMS_CONFIRM, payload.confirm);
    } else if (payload.delete) {
      const res = await apiClient.post(API_URL_PANTRY.DELETE, payload.delete);
    }
    if (payload.ingredients && payload.ingredients.pantryList.length != 0) {
      const res = await apiClient.post(
        API_URL_PANTRY.SCAN_INGREDIENTS_REGISTER,
        payload.ingredients
      );
    }
  },
  updateSaveAddFoodItems: async ({ commit }, foodItems: SaveAddFoodItemData | null) => {
    commit("updateSaveAddFoodItems", foodItems);
  },
  updateSaveDeleteFoodItems: async ({ commit }, foodItems: SaveDeleteFoodItemData | null) => {
    commit("updateSaveDeleteFoodItems", foodItems);
  },
  updateCameraImageUrlMap: async ({ commit }, item: CameraImageUrlItem | null) => {
    commit("updateCameraImageUrlMap", item);
  },
  setOpticalAxis: async ({ commit }, payload: PantryOpticalAxis | null) => {
    // 光軸設定API
    await apiClient.post(API_URL_PANTRY.OPTICAL_AXIS, payload);
  }
};

export default actions;
